import { Typography } from "@material-ui/core";
import { get } from "lodash";
import React from "react";
import { useTranslate } from "react-admin";

const BookmakerTypeField = ({ source, record, basePath, ...props }) => {
	const translate = useTranslate();
	return (
		<Typography {...props}>
			{get(
				record,
				source,
				translate("resources.bookmaker-deals.fields.bookmaker_type.all")
			)}
		</Typography>
	);
};
export default BookmakerTypeField;
